"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPrice = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _utils = require("./utils");
const StyledPrice = exports.StyledPrice = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['oldPriceVisible'])
})(({
  oldPriceVisible,
  theme
}) => ({
  color: (0, _utils.getCurrentPriceColor)(theme, oldPriceVisible)
}));
